import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../../../services/project.service';
import { UserService } from '../../../services/user.service'
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService, SelectItem } from 'primeng/api';
import { MessageServiceComponent } from 'src/services/message.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProjectReviewCommentComponent } from '../project-description/review-comment/review-comment.component';
import { Table } from 'primeng/table';
import { User } from 'src/app/utilities/user';
import { MsalService } from '@azure/msal-angular';
import { log } from 'console';
import { ProjectDetailsService } from '../../../services/project-details.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  providers: [DialogService]
})
export class ProjectsComponent implements OnInit {
  projects: any[] = [];
  projectDetails: any[] = [];
  projectDescriptions: { [key: number]: string } = {};
  projectId = 0;
  currentUser: any
  isAdmin: boolean;
  users: SelectItem[] = [];
  activeUsers: SelectItem[] = [];
  projectStatus: any;
  isVisibleAddProjectDialog = false;
  isVisibleAddProjectDetailsDialog = false;
  clonedProducts: { [s: string]: any; } = {};
  ref: DynamicDialogRef | undefined;
  projectForm: FormGroup = new FormGroup({
    projectId: new FormControl(),
    projectName: new FormControl(''),
    managerId: new FormControl(),
    manager: new FormControl(),
    leadById: new FormControl(),
    leadBy: new FormControl(),
    customerName: new FormControl('')
  });

  viewFilter = false;

  // get project data based on week ranges
  currentDate = new Date();
  startOfWeek: any;
  weekCount: number = -1;
  isPrevClicked: boolean = false;
  startDate: any;
  endDate: any;
  userInfo: any;

  filteredProjects: any[] = [];
  //Project status state variables
  statusOptions = [
    { type: 'Active', value: true },
    { type: 'Inactive', value: false },
    { type: 'All', value: null }
  ];
  selectedStatus = this.statusOptions[0]; 

  selectedProjects: any;
  constructor(private _projectService: ProjectService, private _projectDetailsService:ProjectDetailsService, private breadcrumbService: AppBreadcrumbService, private _userService: UserService, private messageService: MessageService, private messageServiceComponent: MessageServiceComponent, public dialogService: DialogService,private msalService: MsalService) {
    this.breadcrumbService.setItems([
      { label: 'Projects', routerLink: ['/projects'] }
    ]);
  }

  async ngOnInit() {
    await this.fetchUserInfo();

    this.projects = [];
    await this.getAllUsers();
    // await this.getAllProjects();
    await this.getProjectStatus();
    await this.getAllProjectDetails();
    this.messageServiceComponent.getUser().subscribe((res) => {
      this.currentUser = res;
      this.currentUser.isAdmin == null || this.currentUser.isAdmin == false ? this.isAdmin = false : this.isAdmin = true;
    });

    let today = new Date();
    today = this.currentDate;
    
    const { previousWeekStartDate, previousWeekEndDate } = this.getPreviousWeekStartAndEndDates(today);
    
    this.startDate = previousWeekStartDate;
    this.endDate = previousWeekEndDate;
  }

  toggleAddProjectDialog() {
    this.isVisibleAddProjectDialog = !this.isVisibleAddProjectDialog;
  }

  toggleFilter(){
    this.viewFilter = !this.viewFilter;
  }

  async getAllProjects() {
    // await this._projectService.getAllProjects().subscribe((res) => {
    //   this.projects = res;
    // },
    //   (err) => {

    //   });
  }

  async getAllProjectDetails() {
    this.projectDetails = [];
    await this._projectDetailsService.getAllProjectDetails().subscribe((res) => {
      this.projectDetails = res;
    },
      (err) => {
      this.messageService.add({key: 'bc', severity:'error', summary: 'Error', detail: 'Failed to load project details'});
      });
  }

  async getAllUsers() {
  this.users = [];
  this.activeUsers = [];

  this._userService.getAllUsers().subscribe((res) => {

    //  FILTER for active users
    const filteredUsers = (res as Array<any>)
      .filter(user => user.isActive === true || user.isActive === 1)
      .sort((a, b) => a.name.localeCompare(b.name)); // sort by name

     
    filteredUsers.forEach(user => {
      this.activeUsers.push({
        label: user.name,
        value: user.userID
      });
    });
  });
}

  async getProjectStatus() {
    this.projectStatus = await this._projectService.getAllProjectStatus();
  }
  onRowEditInit(product: any) {
    this.clonedProducts[product.projectId] = { ...product };
  }
  async onRowEditSave(project: any) {
    delete this.clonedProducts[project.projectId];
    await this.addOrUpdateProject(project);
  }

  onRowEditCancel(product: any, index: number) {
  }

  async addOrUpdateProject(projectData: any) {
    var project;
    
    if (projectData != undefined && projectData != null) {
      project = {
        "projectID": projectData.projectId == null ? 0 : projectData.projectId,
        "projectName": projectData.projectName,
        "manager": projectData.managerId || projectData.manager,
        "leadBy": projectData.leadById || projectData.leadBy,
        "customerName": projectData.customerName,
        "createdBy": this.currentUser.userId,
        "modifiedBy": this.currentUser.userId
      };

      if (
        project.projectName == null ||
        project.projectName == '' ||
        project.manager == null ||
        project.leadBy == null ||
        project.customerName == '' ||
        project.customerName == null) {
        this.messageService.add({key: 'bc', severity:'error', summary: 'Invalid Input', detail: 'Fields are empty'});
        
      }
      else {
        
        await this._projectService.addUpdateProject(project).subscribe(async (res) => {
        this.messageService.add({key: 'bc', severity:'success', summary: 'Success', detail: res.message});
          
          await this.getAllProjects();
          this._projectService.getAllProjects(this.formatDate(this.startDate), this.formatDate(this.endDate)).subscribe((res) => {
            this.projects = res;
          })
          
          // await this.ngOnInit();
          this.isVisibleAddProjectDialog = false;
          this.projectForm.reset()
          
        },
          (err) => {
          });
      }
      await this.refreshProjectsForCurrentWeek();
    }
  }

  async addProjectDetails(projectDetailsForm: any) {
    if (projectDetailsForm != undefined && projectDetailsForm != null) {
      var project = {
        "projectDetailsId": 0,
        "projectId": projectDetailsForm.projectId,
        "projectDesc": projectDetailsForm.projectDesc,
        "scopeStatus": projectDetailsForm.scopeStatus,
        "scopeDesc": projectDetailsForm.scopeDesc,
        "scheduleStatus": projectDetailsForm.scheduleStatus,
        "scheduleDesc": projectDetailsForm.scheduleDesc,
        "qualityStatus": projectDetailsForm.qualityStatus,
        "qualityDesc": projectDetailsForm.qyalityDesc,
        "budgetStatus": projectDetailsForm.budgetStatus,
        "budgetDesc": projectDetailsForm.budgetDesc,
        "resourceStatus": projectDetailsForm.resourceStatus,
        "resourceDesc": projectDetailsForm.resourceDesc
      };

      await this._projectService.addProjectDetails(project).subscribe((res) => {
        this.messageService.add({key: 'bc', severity:'success', summary: 'Success', detail: res.message});
      },
        (err) => {
        });
      this.getAllProjects();
    }
  }

  async addReviewComments(project: any){
    this.messageServiceComponent.updateProjectId(project.projectId);
    this.ref = this.dialogService.open(ProjectReviewCommentComponent, {
            data:{
                projectId: this.projectId,
            },
            header: 'Project Review Comments',
            width: '70%',
            contentStyle: { overflow: 'hidden' },
            baseZIndex: 10000
        });
  }

  getPreviousWeekStartAndEndDates(currentDate: Date): { previousWeekStartDate: Date, previousWeekEndDate: Date } {
    let dayOfWeek = currentDate.getDay();
    
    const diff = currentDate.getDate() - dayOfWeek - 6;
    
    const previousWeekStartDate = new Date(currentDate);
    previousWeekStartDate.setDate(diff);
    previousWeekStartDate.setHours(0, 0, 0, 0);

    const previousWeekEndDate = new Date(previousWeekStartDate);
    previousWeekEndDate.setDate(previousWeekStartDate.getDate() + 6);
    previousWeekEndDate.setHours(23, 59, 59, 999);

    this.startOfWeek = previousWeekStartDate;
    this.weekCount += 1;      

    this._projectService.getAllProjects(this.formatDate(previousWeekStartDate), this.formatDate(previousWeekEndDate)).subscribe((res) => {
      this.projects = res;
      this.filterProjects();

        this.startDate = previousWeekStartDate;
        this.endDate = previousWeekEndDate;
    });

    return { previousWeekStartDate, previousWeekEndDate };
    
}

  getNextWeekStartAndEndDates(currentDate: Date): { nextWeekStartDate: Date, nextWeekEndDate: Date } {
    let dayOfWeek = currentDate.getDay() - 1;
    if (dayOfWeek === -1) {
        dayOfWeek = 6;
    }

    const diff = currentDate.getDate() - dayOfWeek + 7;
    const nextWeekStartDate = new Date(currentDate);
    nextWeekStartDate.setDate(diff);
    nextWeekStartDate.setHours(0, 0, 0, 0);

    const nextWeekEndDate = new Date(nextWeekStartDate);
    nextWeekEndDate.setDate(nextWeekStartDate.getDate() + 6);
    nextWeekEndDate.setHours(23, 59, 59, 999);

    this.startOfWeek = nextWeekStartDate;
    this.weekCount -= 1;
    
    
    this._projectService.getAllProjects(this.formatDate(nextWeekStartDate), this.formatDate(nextWeekEndDate)).subscribe((res) => {
      this.projects = res;
      this.filterProjects();
      
      this.startDate = nextWeekStartDate;
      this.endDate = nextWeekEndDate;
    })

    return { nextWeekStartDate, nextWeekEndDate };

  }

  formatDate(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDay = day < 10 ? '0' + day : day;
    const formattedMonth = month < 10 ? '0' + month : month;

    return formattedMonth + '-' + formattedDay   + '-' + year;
  } 

  GetPreviousProjects() {
    const { previousWeekStartDate, previousWeekEndDate } = this.getPreviousWeekStartAndEndDates(this.startOfWeek);
    
  }

  GetNextProjects() {
    const { nextWeekStartDate, nextWeekEndDate } = this.getNextWeekStartAndEndDates(this.startOfWeek);
  }

  async updateWeekDates() {
    this.messageServiceComponent.updateWeekStartEndDate({startDate: this.startDate, endDate: this.endDate})
    
  }

  clear(table: Table) {
    table.clear();
  }

  async fetchUserInfo() {
    const emailId = this.msalService.instance.getAllAccounts()[0]?.username;
    if (emailId) {
      try {
        const res = await this._userService.getUserInfo(emailId).toPromise();
        this.userInfo = res;
      } catch (error) {
        console.error('Error retrieving user info:', error);
      }
    } else {
      console.error('Email ID not found');
    }
  }
 

   isActionAllowed(): boolean {
    if(!this.userInfo){return false;}
    const designation = this.userInfo.designation.trim().toLowerCase();
    return this.userInfo ? (this.userInfo.isAdmin || designation==='sr. vice president') : false;
  }

  async toggleStatus(projectId: number) {
    if (projectId != null) { 
      try {
        const updatedProject = await this._projectService.updateProjectStatus(projectId).toPromise();
        this.messageService.add({ key: 'bc', severity: 'success', summary: 'Success', detail: updatedProject.message });

        // await this.getAllProjects();
        // const formattedStartDate = this.formatDate(this.startDate);
        // const formattedEndDate = this.formatDate(this.endDate);

        // this._projectService.getAllProjects(formattedStartDate, formattedEndDate).subscribe((res) => {
        //   this.projects = res;
        // });

        const projectIndex = this.projects.findIndex(p => p.projectId === projectId);
        if (projectIndex !== -1) {
          // Toggle the status locally
          this.projects[projectIndex].isActive = !this.projects[projectIndex].isActive;
          
          // Re-apply the filter to update the table
          this.filterProjects();
        }
        await this.refreshProjectsForCurrentWeek();
       
      } catch (error) {
        console.error('Error toggling project status', error);
        this.messageService.add({ key: 'bc', severity: 'error', summary: 'Error', detail: 'Failed to update project status' });
      }
    } else {
      console.error('Project or project id is not defined');
    }
  }

  loadProjectDescription(projectId: number) {
    // Avoid duplicate calls
    if (this.projectDescriptions[projectId]) return;

    try {

      const foundProject = this.projectDetails.find((project: any) => project.projectId === projectId);
      if (foundProject) {
        var currentProjectDescription = foundProject.projectDesc;
        this.projectDescriptions[projectId] = currentProjectDescription || 'No description available';
      }
      else {
        this.projectDescriptions[projectId] = 'No description available';
      }
    } catch (err) {
      this.projectDescriptions[projectId] = 'Error loading description';
    }
    
  }

  async refreshProjectsForCurrentWeek() {
    const formattedStartDate = this.formatDate(this.startDate);
    const formattedEndDate = this.formatDate(this.endDate);
    
    this._projectService.getAllProjects(formattedStartDate, formattedEndDate).subscribe((res) => {
      this.projects = res;
      this.filterProjects();
    });
  }

  filterProjects() {
    if (!this.projects) {
      this.filteredProjects = [];
      return;
    }
    
    if (this.selectedStatus.value === null) {
      this.filteredProjects = [...this.projects];
    } else {
      this.filteredProjects = this.projects.filter(
        project => project.isActive === this.selectedStatus.value
      );
    }
  }

  onStatusChange(event: any) {
    this.filterProjects();
  }

}
